"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var I18n = require("i18n-js");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_with_select_1 = require("@reverbdotcom/commons/dist/components/form_group_with_select");
var user_context_provider_1 = require("@reverbdotcom/commons/dist/components/user_context_provider");
var bind_1 = require("../bind");
var tokenized_credit_card_hidden_fields_1 = require("./tokenized_credit_card_hidden_fields");
var card_data_1 = require("./card_data");
var with_countries_apollo_1 = require("../components/addresses/with_countries_apollo");
var BillingCreditCardHtmlFormWithoutApolloCountries = /** @class */ (function (_super) {
    tslib_1.__extends(BillingCreditCardHtmlFormWithoutApolloCountries, _super);
    function BillingCreditCardHtmlFormWithoutApolloCountries(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            cardData: tslib_1.__assign(tslib_1.__assign({}, card_data_1.buildCardData()), { cardholderName: props.user.name }),
            billingAddress: tslib_1.__assign(tslib_1.__assign({}, card_data_1.buildBillingCardAddress()), { countryCode: 'US' }),
            tokenizedFields: card_data_1.buildTokenizedCreditCardData(),
        };
        return _this;
    }
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.onFieldUpdate = function (newTokenizedFields) {
        var tokenizedFields = tslib_1.__assign(tslib_1.__assign({}, this.state.tokenizedFields), newTokenizedFields);
        this.setState({ tokenizedFields: tokenizedFields });
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.onCardDataUpdate = function (newCardData) {
        var cardData = tslib_1.__assign(tslib_1.__assign({}, this.state.cardData), newCardData);
        this.setState({ cardData: cardData });
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.onBillingAddressUpdate = function (newAddressData) {
        var billingAddress = tslib_1.__assign(tslib_1.__assign({}, this.state.billingAddress), newAddressData);
        this.setState({ billingAddress: billingAddress });
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.countries = function () {
        return this.props.data.countries.countries;
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.getCountryOptions = function () {
        return this.countries().map(function (country) {
            return {
                value: country.countryCode,
                text: country.name,
            };
        });
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.renderPlaceholder = function () {
        return (React.createElement("p", { className: "formatted-address formatted-address--placeholder" },
            React.createElement("span", { className: "formatted-address__highlight" })));
    };
    BillingCreditCardHtmlFormWithoutApolloCountries.prototype.render = function () {
        if (this.props.data.loading) {
            return this.renderPlaceholder();
        }
        return (React.createElement("div", { className: "scaling-padding-2 bg-offwhite bg--lighten bd-1 bd--offwhite bd-rounded scaling-mb-2" },
            React.createElement(form_group_with_input_1.default, { inputName: "credit_card[cardholder_name]", label: I18n.t('discovery.creditCardForm.nameOnCard'), value: this.state.cardData.cardholderName, updateField: this.onCardDataUpdate, fieldName: "cardholderName", required: true }),
            React.createElement(tokenized_credit_card_hidden_fields_1.default, { onTokenizedFieldUpdate: this.onFieldUpdate, onCardDataUpdate: this.onCardDataUpdate, tokenizedFields: this.state.tokenizedFields, cardData: this.state.cardData }),
            React.createElement("div", { className: "g-container" },
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement(form_group_with_input_1.default, { label: I18n.t('discovery.creditCardForm.postalCode'), fieldName: "postalCode", inputName: "billing_address[postal_code]", value: this.state.billingAddress.postalCode, updateField: this.onBillingAddressUpdate, required: true })),
                React.createElement("div", { className: "g-col-6 g-col-mobile-12 scaling-mb-2" },
                    React.createElement(form_group_with_select_1.default, { label: I18n.t('discovery.creditCardForm.country'), fieldName: "countryCode", inputName: "billing_address[country_code]", updateField: this.onBillingAddressUpdate, value: this.state.billingAddress.countryCode, required: true, options: this.getCountryOptions() }))),
            React.createElement("div", { className: "icon-l-lock size-90" }, I18n.t('discovery.creditCardForm.storedSecurely'))));
    };
    tslib_1.__decorate([
        bind_1.default
    ], BillingCreditCardHtmlFormWithoutApolloCountries.prototype, "onFieldUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingCreditCardHtmlFormWithoutApolloCountries.prototype, "onCardDataUpdate", null);
    tslib_1.__decorate([
        bind_1.default
    ], BillingCreditCardHtmlFormWithoutApolloCountries.prototype, "onBillingAddressUpdate", null);
    return BillingCreditCardHtmlFormWithoutApolloCountries;
}(React.Component));
exports.BillingCreditCardHtmlFormWithoutApolloCountries = BillingCreditCardHtmlFormWithoutApolloCountries;
var BillingCreditCardHtmlForm = with_countries_apollo_1.default(user_context_provider_1.withUserContext(BillingCreditCardHtmlFormWithoutApolloCountries));
exports.BillingCreditCardHtmlForm = BillingCreditCardHtmlForm;
exports.default = BillingCreditCardHtmlForm;
//# sourceMappingURL=billing_credit_card_html_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/billing_credit_card_html_form.js
// module id = AXYF
// module chunks = 20 21 22